import { LicenseTierDto } from '../generated-types/licenseTierDto';

/**
 * Calculates the total price based on the license count and tiered pricing.
 *
 * @param {number} licenseCount - The number of licenses.
 * @param {Array<LicenseTierDto>} tiers - An array of pricing tier objects.
 * @returns {number} - The calculated total price.
 */
export function calculateTotal(
  licenseCount: number,
  tiers: LicenseTierDto[]
): number {
  if (!tiers || tiers.length === 0) return 0;

  let calculatedPrice = 0;
  for (let i = 0; i < tiers.length; i++) {
    if (i < tiers.length - 1) {
      if (licenseCount < tiers[i + 1].min) {
        calculatedPrice = tiers[i].yearlyPrice * licenseCount;
        break;
      }
    } else {
      calculatedPrice = tiers[i].yearlyPrice * licenseCount;
    }
  }
  return calculatedPrice;
}
